var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoctors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.28 74.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#69aa44;}.cls-2{fill:#8ac148;}.cls-3{fill:#231f20;fill-rule:evenodd;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,37.22C0,29.35,0,21.48,0,13.6.06,5.34,6.3-.08,15.07,0,28.34.13,41.45,2,54.62,3.05c2.88.24,5.76.41,8.62.75,6.55.78,11.8,5.85,11.88,12.08.19,14.23.24,28.46,0,42.69-.08,5.36-4.69,11.56-12.08,12.15Q47.23,72,31.43,73.57c-6.63.66-13.27,1.34-19.9.56A13,13,0,0,1,0,61.75C0,53.57,0,45.4,0,37.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.39,37.24c0-7.87,0-15.73,0-23.6C4.43,5.38,10.31,0,18.57.05,31.07.18,43.41,2,55.82,3.1c2.71.24,5.43.41,8.12.75A12.58,12.58,0,0,1,75.13,15.91c.18,14.22.22,28.45,0,42.66A12.67,12.67,0,0,1,63.76,70.72Q48.86,72,34,73.56c-6.24.66-12.49,1.35-18.74.57A12.74,12.74,0,0,1,4.42,61.75c-.08-8.17,0-16.34,0-24.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.49,16.32l20.1,43.06a1.54,1.54,0,0,1-1,2.34c-4.9,1.52-6.11-2.64-7.83-5.12L35.7,32.74a.47.47,0,0,0-.81,0c-.49.52-8.9,8.45-8.9,8.45-4,4.12-8.75,2.3-7.65,0L25,31.28c5.13-7.89-.58-6.45-.9-17.09A2.41,2.41,0,0,1,27,11.48s5.14,1.09,7.25,1.46C37.09,13.31,38.49,16.32,38.49,16.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.62,37.92l4.1,6.76a2,2,0,0,1-.26,2.13L27.92,61.71C25.23,65.47,21,61.29,24.25,56c0,0,9.4-17.3,9.71-17.92A.9.9,0,0,1,35.62,37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.39,42.85l6.36-3.1a.77.77,0,0,1,.37-.08,1.26,1.26,0,0,1,.33,0,1.8,1.8,0,0,0,.11-.67,4.57,4.57,0,0,0-.49-1.91c-.57-1.18-1.47-2-2-1.94a.54.54,0,0,0-.25.06L40.15,38.5c-.27.12-.44.49-.44,1a4.6,4.6,0,0,0,.5,1.91A3.67,3.67,0,0,0,42,43.33.92.92,0,0,1,42.39,42.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.69,47.45,51,44.35a1,1,0,0,1,.38-.08,1.3,1.3,0,0,1,.48.12,2.06,2.06,0,0,0,.05-.45,4.37,4.37,0,0,0-.48-1.83h0a3.29,3.29,0,0,0-1.77-1.83.61.61,0,0,1-.16.12l-6.63,3.23a.61.61,0,0,1-.24.06,1.45,1.45,0,0,0-.16.72A4.34,4.34,0,0,0,43,46.24a4,4,0,0,0,1.31,1.61A.94.94,0,0,1,44.69,47.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.87,51.88l6.35-3.1a.8.8,0,0,1,.37-.08l.25,0a1.9,1.9,0,0,0,0-.44,4.34,4.34,0,0,0-.48-1.83h0a3.68,3.68,0,0,0-1.56-1.76.58.58,0,0,1-.26.29l-6.35,3.1a.53.53,0,0,1-.25,0,.85.85,0,0,1-.39-.09,1.53,1.53,0,0,0-.15.71,4.34,4.34,0,0,0,.48,1.83,3.82,3.82,0,0,0,1.52,1.74A.88.88,0,0,1,46.87,51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.72,34.56a7.44,7.44,0,0,0-2.51,1.62c.61-1.84,1.24-5.16.25-4.45a9,9,0,0,0-2.13,3.07c.37-.07,1.58,2.18,1.58,2.18a9.66,9.66,0,0,1,.47,2.32C51.44,38.29,54.11,34.17,52.72,34.56Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctors);
export default __webpack_public_path__ + "static/media/doctors.3a953aa1569820c69ade736158bd9c31.svg";
export { ForwardRef as ReactComponent };